import React from 'react';
import './App.css';
import SportekWebsite from './components/SportekWebsite';

function App() {
  return (
    <div className="App">
      <SportekWebsite />
    </div>
  );
}

export default App;